/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_top_ups_modal_validation_email_valid = /** @type {(inputs: {}) => string} */ () => {
	return `Ingresa un correo válido`
};

const en_top_ups_modal_validation_email_valid = /** @type {(inputs: {}) => string} */ () => {
	return `Enter a valid email`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const top_ups_modal_validation_email_valid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.top_ups_modal_validation_email_valid(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("top_ups_modal_validation_email_valid", locale)
	if (locale === "es") return es_top_ups_modal_validation_email_valid(inputs)
	return en_top_ups_modal_validation_email_valid(inputs)
};
export { top_ups_modal_validation_email_valid as "top_ups.modal.validation.email_valid" }